import React, { useEffect, useRef, useState } from 'react';
import { Box, Divider, IconButton, Drawer as MuiDrawer, Stack, Typography, styled } from '@mui/material';
// import { useElementSize } from 'usehooks-ts';

// import { useAppBarHeight } from 'hooks';

import { DRAWER_WIDTH, HEADER_HEIGHT, RIGHT_BOTTOM_BORDER } from 'config';
import Icon from '../Icon';

import { SideDrawerProps } from './types';

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: DRAWER_WIDTH,
    borderLeft: '1px solid rgba(182, 182, 182, 0.30)',
    background: 'rgba(255, 255, 255, 255)',
    backdropFilter: 'blur(2px)',
    boxShadow: 'none',
    top: 'auto',
    bottom: 0,
    zIndex: 1000
  }
}));

const SideDrawer = ({ heading, children, handleClose, footer, ...props }: SideDrawerProps) => {
  // const [footerRef, { height: footerHeight }] = useElementSize();
  // const [headingRef, { height }] = useElementSize();
  // const appbarHeight = useAppBarHeight();

  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);
  const headingRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
    }
  }, []);

  useEffect(() => {
    if (headingRef.current) {
      setHeaderHeight(headingRef.current.offsetHeight);
    }
  }, []);

  return (
    <Drawer
      {...props}
      sx={{
        // height: `calc(100% - ` + (HEADER_HEIGHT + RIGHT_BOTTOM_BORDER) + `px)`,
        '& .MuiDrawer-paper': {
          height: `calc(100% -  ` + (HEADER_HEIGHT + RIGHT_BOTTOM_BORDER) + `px)`,
          marginBottom: RIGHT_BOTTOM_BORDER + 'px'
        }
      }}
      anchor="right"
      onClose={handleClose}
      hideBackdrop={true}
      variant="persistent"
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        px={2}
        py={2}
        sx={{ borderTop: '1px solid #E9E9E9' }}
      >
        <Box ref={headingRef}>
          {typeof heading === 'string' ? <Typography fontWeight={600}>{heading}</Typography> : heading}
        </Box>
        <IconButton onClick={handleClose} sx={{ borderRadius: '4px', padding: '0' }}>
          <Icon name="close" size={'24'} />
        </IconButton>
      </Stack>
      <Divider />
      <Box
        px={2}
        py={2}
        sx={theme => ({
          height: `calc(100% - ${footerHeight}px - ${headerHeight}px - 16px)`,
          overflowY: 'auto'
        })}
      >
        {children}
      </Box>
      {footer ? (
        <Box ref={footerRef} px={2} py={2} sx={{ width: '100%' }}>
          {footer}
        </Box>
      ) : null}
    </Drawer>
  );
};

export default SideDrawer;
